__turbopack_context__.v({
  "newsletterImgContainer": "NewsLetter-module__zN1a1W__newsletterImgContainer",
});
